import React from 'react';
import { Divider, Typography } from '@mui/material';
import sorisha from '../../../../../images/Agri-info/crops/sorisha_সরিষা.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const SorishaInfo = () => {

    // dynamic title
    useDocumentTitle("সরিষা");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                সরিষা
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={sorisha} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text fw-bold">ভূমিকা:</p>
                            <p className="card-text">সরিষা বাংলাদেশের প্রধান ভোজ্য তেল ফসল। বর্তমানে প্রায় সাড়ে ৩ লক্ষ হেক্টর জমিতে এর চাষাবাদ করা হয় এবং প্রায় আড়াই লক্ষ টন তেল পাওয়া যায়। বিভিন্ন জাতরে সরিষার বীজে প্রায় ৪০-৪৪% তেল থাকে। খৈলে প্রায় ৪০% আমিষ থাকে। তাই খৈল গরু ও মহিষের জন্য খুব পুষ্টিকর খাদ্য।</p>
                            <p>বাংলাদেশে ৩ প্রকার সরিষার চাষ করা হয়। এ গুলো হলো-টরি, শ্বেত ও রাই।</p>

                            <p className="card-text fw-bold">সরিষার জাত</p>
                            <p className="card-text fw-bold">টরি-৭</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p>ফসল বোনা থেকে পাকা পর্যন্ত ৭০-৮০ দিন সময় লাগে। উন্নত পদ্দতিতে চাষ করলে হেক্টর প্রতি ফলন ৯৫০-১১০০ কেজি হয়। বীজে তেলের পরিমাণ ৩৮-৪১%। জাতটি রোগবালাই সহনশীল।</p>

                <p className="card-text fw-bold">সোনালী সরিষা (এসএস-৭৫)</p>
                <p className="card-text">ফলে ৪ টি কক্ষ থাকে এবং প্রতি ফলে বীজের সংখ্যা ৩৫-৪৫ টি । বীজের রং হলদে সোনালী । বীজ গোলাকার।হাজার বীজের ওজন ৩.৫-৪.৫ গ্রাম এবং বীজে তেলের পরিমাণ ৪৪-৪৫%। গাছের কান্ড ও শিকড় শক্ত বলে অধিক সার ও সেচ প্রয়োগে গাছ নুয়ে পড়ে না।</p>

                <p className="card-text fw-bold">কল্যাণীয়া (টিএস-৭২) </p>
                <p className="card-text">বীজ গোলাকার। হাজার বীজের ওজন ২.৫-৩.০ গ্রাম। বীজে তেলের পরিমাণ ৪০-৪২%। ফসল পাকতে ৭৫-৮৫ দিন সময় লাগে। উন্নত পদ্দতিতে চাষ করলে প্রতি হেক্টরে ১.৪৫-১.৬৫ টন ফলন পাওয়া যায়। কল্যাণীয়া জাতটি স্বল্প মেয়াদী উচ্চ ফলনশীল আগাম জাত।</p>

                <p className="card-text fw-bold">দৌলত ( আর এস-৮১)</p>
                <p className="card-text">বপন থেকে তোলা পর্যন্ত ৯০-১০৫ দিন সময় লাগে। হেক্টর প্রতি ফলন ১.১-১.৩ টন। দৌলত জাত খরা ও কিছুটা লবনাক্ততা সহনশীল। বীজে তেলের পরিমাণ ৩৯-৪০%। জাতটি অলটারনারিয়া ব্লাইট রোগ সহনশীল।</p>

                <p className="card-text fw-bold">বারি সরিষা -৬ (ধলি)</p>
                <p className="card-text">ফল ২ কক্ষ বিশিষ্ট এবং প্রতি ফলে বীজের সংখ্যা ২২-২৫ টি। হাজার বীজের ওজন ৩-৪ গ্রাম। বীজের রং হলদে। কান্ড ও শিকড় শক্ত হওয়ায় গাছ হেলে পড়ে না। পরিপক্ক ফল ফেটে গিয়ে বীজ ঝরে পড়ে না। ফল ও ফলের ঠোঁট তুলনামূলকভাবে লম্বা। বারি সরিষা -৬ (ধলি) পাকতে ৯০-১০০ দিন সময় লাগে। পরিমাণমত সার ও সেচ দিলে প্রতি হেক্টরে ১.৯-২.২ টন ফলন পাওয়া যায়। বীজে তেলের পরিমাণ ৪৪-৪৫%।</p>

                <p className="card-text fw-bold">বারি সরিষা -৮ (ন্যাপাস-৮৫০৯)</p>
                <p className="card-text">ফুলের পাঁপড়ির রং হলদে। প্রতি গাছে ফলের সংখ্যা ৯০-১২৫ টি, ফল ২ কক্ষ বিশিষ্ট । প্রতি ফলে বীজের সংখ্যা ২৫-৩০ টি। বীজের রং কালচে। হাজার বীজের ওজন ৩.৪-৩.৬ গ্রাম। ফসল পাকতে ৯০-৯৫ দিন সময় লাগে।বীজে তেলের পরিমাণ ৪৩-৪৫%। এ জাত অলটারনারিয়া ব্লাইট রোগ ও সাময়িক জলাবদ্দতা  সহনশীল।</p>

                <p className="card-text fw-bold">রাই-৫</p>
                <p className="card-text">
                    প্রতি গাছে ৪-৬ টি প্রাথমিক শাখা থাকে। পাতা বোটাযুক্ত ও খসখসে। প্রস্ফুটিত ফুল কুড়ির নিচে অবস্থান করে।প্রতি গাছে ফলের সংখ্যা ৯০-১২০। বীজে তেলের পরিমাণ ৩৯-৪০%।</p>

                <p className="card-text fw-bold">বারি সরিষা -৯</p>
                <p className="card-text">এ জাতটি  ‌টরি-৭ এর চেয়ে শতকরা ১০-২৫ ভাগ বোশ ফলন দেয়। আমন ধান কাটার পর এবং বোরো ধান চাষের আগে। স্বল্প মেয়াদী এ জাতটি সহজে চাষ করা সম্ভব। বীজে তেলের পরিমাণ শতকরা ৪৩-৪৪ ভাগ। ফসল পাকতে ৮০-৮৫ দিন সময় লাগে। পরিমাণমত সার ও সেচ দিলে হেক্টরে ১.২৫-১.৪৫ টন ফলন পাওয়া যায়। </p>

                <p className="card-text fw-bold">বারি সরিষা -১০</p>
                <p className="card-text">গাছের উচ্চতা ৯০-১০০ সেমি। প্রতি গাছে ৪-৬ টি প্রাথমিক শাখা থাকে। শাখা থেকে প্রশাখা বের হয়। পাতা হালকা সবুজ রংয়ের। পাতা  বোটাযুক্ত ও খসখসে । প্রতি গাছে ফলের সংখ্যা ১০০-১২০ টি । ফল ২ কক্ষ বিশিষ্ট । প্রতি পলে বীজের সংখ্যা ১২-১৫ টি । বীজের রং পিঙ্গঁল । হাজার বীজের ওজন ২.০-৩.০ গ্রাম। বীজে তেলের পরিমাণ শতকরা ৪২-৪৩ ভাগ। হেক্টর প্রতি ফলন ১.২৫-১.৪৫ টন। আমন ধান কাটার পর এ জাতটি নাবি জাত হিসাবে চাষ করা যায়।</p>

                <p className="card-text fw-bold">বারি সরিষা -১১</p>
                <p className="card-text">হাজার বীজের ওজন ৩.৫-৪.০ গ্রাম। বীজের ওজন অন্যান্য রাই সরিষার চেয়ে বেশি। ফসল ১০৫-১১০ দিন পাকে। প্রতি হেক্টরে ২.০-২.৫ টন ফলন পাওয়া যায়। এ জাতটি দৌলতের চেয়ে ২০-২৫% বেশি ফলন দেয়। আমন ধান কাটার পর এ জাতটি নাবি জাত হিসাবে চাষ করা যায়। জাতটি খরা এবং লবনাক্ত সহনশীল। প্রতি ফলে বীজের সংখ্যা ১২-১৫ টি। বীজের রং পিঙ্গল।</p>

                <p className="card-text fw-bold">বারি সরিষা -১২</p>
                <p className="card-text">হাজার বীজের ওজন ২.৬-৩.২ গ্রাম। বীজে তেলের পরিমাণ ৪৩- ৪৪%। ফসল ৭৮-৮৫ দিনে পাকে। প্রতি হেক্টরে ১.৪৫-১.৬৫ টন ফলন পাওয়া যায়। আমন ধান কাটার পর স্বল্প মেয়াদী জাত হিসেবে চাষ করে বোরো ধান রোপণ করা যায়।</p>

                <p className="card-text fw-bold">বারি সরিষা-১৩:</p>
                <p className="card-text">হেক্টর প্রতি ফলন ২.২০-২.৮০ টন। ফসল ৯০-৯৫ দিনে পাকে। বীজে তেলের পরিমান শতকরা প্রায় ৪৩ ভাগ।</p>

                <p className="card-text fw-bold">বারি সরিষা -১৪</p>
                <p className="card-text">হাজার বীজের ওজন ৩.৫-৩.৯ গ্রাম।  ফসল ৭৫-৮০ দিনে পাকে। প্রতি হেক্টরে ১.৪-১.৬ টন ফলন পাওয়া যায়। আমন ধান কাটার পর স্বল্প মেয়াদী জাত হিসেবে চাষ করে বোরো ধান রোপণ করা যায়।</p>

                <p className="card-text fw-bold">বারি সরিষা -১৫</p>
                <p className="card-text">হাজার বীজের ওজন ৩.২৫-৩.৫০ গ্রাম। ফসল ৮০-৮৫ দিনে পাকে। প্রতি হেক্টরে ১.৫৫-১.৬৫ টন ফলন পাওয়া যায়। আমন ধান কাটার পর স্বল্প মেয়াদী জাত হিসেবে চাষ করে বোরো ধান রোপণ করা যায়।</p>

                <p className="card-text fw-bold">বারি সরিষা -১৬</p>
                <p className="card-text">হাজার বীজের ওজন ৪.৭-৪.৯ গ্রাম। ফসল ১০৫-১১৫ দিনে পাকে। প্রতি হেক্টরে ২.০-২.৫ টন ফলন পাওয়া যায়। আমন ধান কাটার পর  বোরো ধান করে না এমন জমিতে এ জাতটি নাবি জাত হিসেবে চাষ করা যায়। এ জাতটি খরা ও লবনাক্ততা সহিষ্ঞু।</p>

                <p className="card-text fw-bold">বিনাসরিষা-৪</p>
                <p className="card-text">হাজার বীজের ওজন ৩.৫০-৩.৮০ গ্রাম। বীজের রঙ লালচে কালো এবং বীজে তেলের পরিমাণ ৪৪% । জীবনকাল ৮০-৮৫ দিন। সর্বোচ্চ ২.৪০ টন /হেক্টর ফলন পাওয়া যায়। তবে হেক্টর প্রতি গড় ফলন ১.৭০ টন।</p>

                <p className="card-text fw-bold">বিনা সরিষা-৭</p>
                <p className="card-text">জাতটি খরা এবং অল্টারনারিয়া জনিত পাতা ও ফলের ঝলসানো রোগ সহনশীল। বীজের আকার তুলনামূলকভাবে বড় এবং ১০০০ বীজের ওজন ৩.৫০-৪.২৫ গ্রাম। বীজে তেলের পরিমাণ ৩৬-৩৮%। জীবনকাল ১০২-১১০ দিন। হেক্টর প্রতি ফলন ২.০ টন।</p>

                <p className="card-text fw-bold">বিনা সরিষা-৮</p>
                <p className="card-text">বীজে তেলের পরিমাণ ৩৯-৪১%। জীবনকাল ১০০-১০৮ দিন। হেক্টর প্রতি ফলন ২.৪ টন।</p>

                <p className="card-text fw-bold">বিনা সরিষা-৯</p>
                <p className="card-text">জাতটি অল্টারনারিয়া জনিত পাতা ও ফলের ঝলসানো রোগ এবং বৃষ্টিজনিত সাময়িক জলাবদ্ধতা  সহনশীল। বীজে তেলের পরিমাণ ৪৩%। জীবনকাল ৮০-৮৪ দিন। হেক্টর প্রতি ফলন গড়ে ১.৬০ টন।</p>

                <p className="card-text fw-bold">বিনা সরিষা-১০</p>
                <p className="card-text">বীজে তেলের পরিমাণ ৪২%। জীবনকাল ৭৮-৮২ দিন। হেক্টর প্রতি ফলন ১.৫ টন।</p>

                <p className="card-text fw-bold">বপন পদ্ধতি:</p>
                <p className="card-text">সরিষা বীজ সাধারণত ছিটিয়ে বপন করা হয়। লাইন করে বুনলে সার, সেচ ও নিড়ানী দিতে সুবিধা হয়। লাইন থেকে লাইনের দূরত্ব ১ ফুট রাখতে হয়। বপনের সময় জমিতে প্রয়োজনীয় রস থাকা দরকার।</p>

                <p className="card-text fw-bold">বপনের সময়:</p>
                <p className="card-text">বিভিন্ন অঞ্চলের তারতম্য এবং জমির জো অবস্থা অনুযায়ী টরি-৭, কল্যাণীয়া, সোনালী সরিষা, বারি সরিষা-৬, বারি সরিষা-৭ ও বারি সরিষা-৮ এর বীজ মধ্য আশ্বিন থেকে মধ্য কার্তিক মাস পর্যন্ত বোনা যায়। রাই-৫ এবং দৌলত কার্তিক থেকে অগ্রহায়ণ মাস পর্যন্ত বপন করা যেতে পারে।</p>

                <p className="card-text fw-bold">নিড়ানী দেয়া:</p>
                <p className="card-text">বীজ বপনের ১৫-২০ দিন পর একবার এবং ফুল আসার সময় দ্বিতীয়বার নিড়ানি দিতে হয়।</p>

                <p className="card-text fw-bold">সেচ প্রয়োগ:</p>
                <p className="card-text">বীজ বপনের ২৫-৩০ দিনের মধ্যে (গাছে ফুল আসার সময়) প্রথম সেচ এবঙ ৫০-৫৫ দিসের মধ্যে (ফল ধরার সময়) দ্বিতীয় সেচ দিতে হবে। বপনের সময় মাটিতে রস কম থাকলে চারা গজানোর ১০-১৫ দিনের মধ্যে একটি হালকা সেচ দিতে হয়।</p>

                <p className="card-text fw-bold">সারের পরিমান :</p>
                <p className="card-text">জাত, মাটি এ মাটিতে রসের তারতম্য অনুসারে সার দিতে হয়। </p>

                <p className="card-text fw-bold">সরিষার জাব পোকা :</p>
                <p className="card-text fw-bold">লক্ষণ: </p>
                <p className="card-text">পূর্ণবয়স্ক ও বাচ্চা পোকা উভয়ই সরিষার পাতা, কান্ড, ফুল ও ফল হতে রস শোষণ করে। আক্রমণের মাত্রা বেশি হলে ফুল ও ফলের বৃদ্ধি বাধাপ্রাপ্ত হয় এবং পাতা কুঁকড়ে যায়। জাব পোকা এক ধরনের রস নিঃসরণ করে, ফলে তাতে সুটিমোল্ড ছত্রাক জন্মে এবং আক্রান্ত অংশ কালো দেখায়। এজন্য ফল ঠিকমত বাড়তে পারে না, বীজ আকারে ছোট হয়। বীজে তেলের পরিমাণ কমে যায়। ফল ধারণ অবস্থায় বা তার আগে আক্রমণ হলে এবং প্রতিকার ব্যবস্থা গ্রহণ না করলে সম্পূর্ণ ফসল নষ্ট হওয়ার আশংকা থাকে। </p>

                <p className="card-text fw-bold">প্রতিকার :</p>
                <p className="card-text">
                    ১. আগাম চাষ আশ্বিনের শেষ ভাগ ও মধ্য-কার্তিক (অক্টোবর) অর্থাৎ আগাম সরিষা বপন করলে জাব পোকার আক্রমণের আশংকা কম থাকে।<br />
                    ২. প্রতি গাছে ৫০ টির বেশি পোকা থাকলে ম্যালাথিয়ন-৫৭ ইসি বা সুমিথিয়ন-৫৭ ইসি বা ফলিথিয়ন-৫৭ ইসি বা একোথিয়ন-৫৭ ইসি ডায়াজিনন ৬০ ইসি প্রতি লিটার পানিতে ২ মিলি হারে মিশিয়ে বিকালে সেপ্র করতে হবে।</p>

                <p className="card-text fw-bold">সরিষার পাতা ঝলসানো রোগ</p>
                <p className="card-text fw-bold">লক্ষণ: </p>
                <p className="card-text">প্রাথমিক অবস্থায় সরিষা গাছের নীচে বয়স্ক পাতায় এ রোগের লক্ষণ পরিলক্ষিত হয়। পরবর্তীতে এ ছত্রাকের আক্রমণে গাছের পাতা, কান্ড ও ফলে চক্রাকার কালচে দাগের সৃষ্টি হয়। আক্রমণের মাত্রা বেশি হলে পাতা ঝলসে যায়। ফলে সরিষার ফলন খুব কমে যায়। </p>

                <p className="card-text fw-bold">প্রতিকার :</p>
                <p className="card-text">
                    ১. রোগ প্রতিরোধ ক্ষমতা সম্পন্ন জাতের সরিষার চাষ করতে হবে। ধলি, দৌলত, বারি সরিষা-৭, বারি সরিষা-৮ ইত্যাদি জাত কিছুটা পাতা ঝলসানো রোগ সহনশীল।<br />
                    ২. রোগমুক্ত বীজ বপন করতে হবে।<br />
                    ৩. বীজ বপনের আগে ভিটাভেক্স-২০০ দিয়ে (২-৩ গ্রাম ছত্রাকনাশক/কেজি বীজ) বীজ শোধন করে বপন করতে হবে।<br />
                    ৪. এ রোগ দেখা দেওয়ার সাথে সাথে রোভরাল-৫০ ডব্লিউপি বা ডাইথেন এম-৪৫, ০.২% হারে (প্রতি লিটার পানির সাথে ২ গ্রাম) পানিতে মিশিয়ে ২০-১২ দিন পরপর ৩-৪ বার সেপ্র করতে হবে।</p>

                <p className="card-text fw-bold">পরজীবী উদ্ভিদজনিত রোগ </p>
                <p className="card-text fw-bold">লক্ষণ : </p>
                <p className="card-text">সরিষার পরজীবী উদ্ভিদের মধ্যে অরোবাংকিই প্রধান। সরিষা গাছের শিকড়ের সাথে এ পরজীবী উদ্ভিদ সংযোগ স্থাপন করে খাদ্য সংগ্রহ করে বেঁচে থাকে। এর ফলে পরজীবী আক্রান্ত সরিষার গাছ দুর্বল হয়, বৃদ্ধি কমে যায় এবং ফলন হ্রাস পায়। অরোবাংকি এক প্রকার সপুষ্কক পরজীবী উদ্ভিদ এবং এর বংশবৃদ্ধি সরিষা গাচের উপর নির্ভরশীল। এর বীজ মাটিতেই অবস্থান করে। মাটি, ফসলের পরিত্যক্ত অংশ, সেচের পানি প্রভৃতির মাধ্যমে অরোবাংকির উৎপত্তি ও বিস্তার ঘটে। বারবার একই জমিতে সরিষা পরিবারের ফসল চাষ করলে এ পরজীবীর বিস্তার ঘটে। </p>

                <p className="card-text fw-bold">প্রতিকার :</p>
                <p className="card-text">
                    ১. ফুল আসর আগে পরজীবী উদ্ভিদ জমি হতে তুলে ধ্বংস করে ফেলতে হবে।<br />
                    ২. পরিমিত হারে টিএসপি সার ব্যবহার করতে হবে।<br />
                    ৩. আগে এ রোগে আক্রান্ত জমি গভীরভাবে চাষ করতে হবে।</p>

            </div>
        </div >


    );
};

export default SorishaInfo;